import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes } from './routes';
import { AdminRoute } from './guards/AdminRoute';
import { DashboardRoute } from './guards/DashboardRoute';
import { GestionPsyRoute } from './guards/GestionPsyRoute';
import { InterventionRoute } from './guards/InterventionRoute';
import { NotRequireAuth } from '../auth/NotRequireAuth';
import { AppLayout } from '../layouts/AppLayout';
import { PageLoader } from '../../shared/ui';
import Login from '../../features/users/pages/LoginPage';
import Responses from '../../features/users/pages/ResponsesPage';
import {
  AdministratifStatus,
  Certifications,
  Company,
  Dashboard,
  EditAccount,
  EditUserAccount,
  Experiences,
  Expertises,
  Interventions,
  JournalisationConnexion,
  Languages,
  ManageAdministratifStatus,
  ManageCertification,
  ManageCompany,
  ManageExperiences,
  ManageExpertise,
  ManageIntervention,
  ManageLanguage,
  ManageOfficeSpecialist,
  ManageProspect,
  ManageSocialWorker,
  ManageSpecialist,
  ManageSpecialities,
  NewIntervention,
  ProspectList,
  RestoreSpecialist,
  ShowOfficeSpecialist,
  ShowProspect,
  ShowSocialWorker,
  ShowSpecialist,
  SocialWorkerList,
  Specialities,
  SpecialistList,
  SpecialistsMapFilter,
  UserAccount,
} from './lazyPages';
import { RequireAdministrativeTypes } from './RequireAdministrativeTypes';

function SuspensePage({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path={routes.login}
        element={
          <NotRequireAuth>
            <Login />
          </NotRequireAuth>
        }
      />
      <Route
        path={routes.ReponseSMS}
        element={
          <NotRequireAuth>
            <Responses />
          </NotRequireAuth>
        }
      />
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to={routes.specialistList} replace />} />
        <Route
          path={routes.specialistList}
          element={
            <SuspensePage>
              <SpecialistList />
            </SuspensePage>
          }
        />
        <Route
          path={routes.socialWorkerList}
          element={
            <SuspensePage>
              <SocialWorkerList />
            </SuspensePage>
          }
        />
        <Route
          path={routes.interventions}
          element={
            <SuspensePage>
              <Interventions />
            </SuspensePage>
          }
        />
        <Route element={<InterventionRoute />}>
          <Route
            path={routes.newIntervention}
            element={
              <SuspensePage>
                <NewIntervention />
              </SuspensePage>
            }
          />
        </Route>
        <Route element={<DashboardRoute />}>
          <Route
            path={routes.dashboard}
            element={
              <SuspensePage>
                <Dashboard />
              </SuspensePage>
            }
          />
        </Route>
        <Route element={<RequireAdministrativeTypes />}>
          <Route
            path={routes.editIntervention}
            element={
              <SuspensePage>
                <ManageIntervention />
              </SuspensePage>
            }
          />
          <Route
            path={routes.specialistsMap}
            element={
              <SuspensePage>
                <SpecialistsMapFilter />
              </SuspensePage>
            }
          />
        </Route>
        <Route
          path={routes.addSpecialistList}
          element={
            <SuspensePage>
              <ManageSpecialist />
            </SuspensePage>
          }
        />
        <Route
          path={routes.addSocialWorkerList}
          element={
            <SuspensePage>
              <ManageSocialWorker />
            </SuspensePage>
          }
        />
        <Route
          path={routes.editSpecialistList}
          element={
            <SuspensePage>
              <ManageSpecialist />
            </SuspensePage>
          }
        />
        <Route
          path={routes.editSocialWorkerList}
          element={
            <SuspensePage>
              <ManageSocialWorker />
            </SuspensePage>
          }
        />
        <Route
          path={routes.convertSpecialist}
          element={
            <SuspensePage>
              <ManageSpecialist />
            </SuspensePage>
          }
        />
        <Route
          path={routes.showSpecialistList}
          element={
            <SuspensePage>
              <ShowSpecialist />
            </SuspensePage>
          }
        />
        <Route
          path={routes.showSocialWorkerlist}
          element={
            <SuspensePage>
              <ShowSocialWorker />
            </SuspensePage>
          }
        />
        <Route element={<AdminRoute />}>
          <Route
            path={routes.userAccount}
            element={
              <SuspensePage>
                <UserAccount />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editUserAccount}
            element={
              <SuspensePage>
                <EditUserAccount />
              </SuspensePage>
            }
          />
        </Route>
        <Route element={<GestionPsyRoute />}>
          <Route
            path={routes.company}
            element={
              <SuspensePage>
                <Company />
              </SuspensePage>
            }
          />
          <Route
            path={routes.specialities}
            element={
              <SuspensePage>
                <Specialities />
              </SuspensePage>
            }
          />
          <Route
            path={routes.experiences}
            element={
              <SuspensePage>
                <Experiences />
              </SuspensePage>
            }
          />
          <Route
            path={routes.expertises}
            element={
              <SuspensePage>
                <Expertises />
              </SuspensePage>
            }
          />
          <Route
            path={routes.languages}
            element={
              <SuspensePage>
                <Languages />
              </SuspensePage>
            }
          />
          <Route
            path={routes.administratifStatus}
            element={
              <SuspensePage>
                <AdministratifStatus />
              </SuspensePage>
            }
          />
          <Route
            path={routes.certifications}
            element={
              <SuspensePage>
                <Certifications />
              </SuspensePage>
            }
          />
          <Route
            path={routes.newCompany}
            element={
              <SuspensePage>
                <ManageCompany />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editCompany}
            element={
              <SuspensePage>
                <ManageCompany />
              </SuspensePage>
            }
          />
          <Route
            path={routes.newSpecialities}
            element={
              <SuspensePage>
                <ManageSpecialities />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editSpecialities}
            element={
              <SuspensePage>
                <ManageSpecialities />
              </SuspensePage>
            }
          />
          <Route
            path={routes.newExperiences}
            element={
              <SuspensePage>
                <ManageExperiences />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editExperiences}
            element={
              <SuspensePage>
                <ManageExperiences />
              </SuspensePage>
            }
          />
          <Route
            path={routes.newExpertises}
            element={
              <SuspensePage>
                <ManageExpertise />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editExpertises}
            element={
              <SuspensePage>
                <ManageExpertise />
              </SuspensePage>
            }
          />
          <Route
            path={routes.newLanguages}
            element={
              <SuspensePage>
                <ManageLanguage />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editLanguages}
            element={
              <SuspensePage>
                <ManageLanguage />
              </SuspensePage>
            }
          />
          <Route
            path={routes.newAdministratifStatus}
            element={
              <SuspensePage>
                <ManageAdministratifStatus />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editAdministratifStatus}
            element={
              <SuspensePage>
                <ManageAdministratifStatus />
              </SuspensePage>
            }
          />
          <Route
            path={routes.newCertifications}
            element={
              <SuspensePage>
                <ManageCertification />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editCertifications}
            element={
              <SuspensePage>
                <ManageCertification />
              </SuspensePage>
            }
          />
          <Route
            path={routes.restore}
            element={
              <SuspensePage>
                <RestoreSpecialist />
              </SuspensePage>
            }
          />
          <Route
            path={routes.prospects}
            element={
              <SuspensePage>
                <ProspectList />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editProspectList}
            element={
              <SuspensePage>
                <ManageProspect />
              </SuspensePage>
            }
          />
          <Route
            path={routes.showProspectList}
            element={
              <SuspensePage>
                <ShowProspect />
              </SuspensePage>
            }
          />
          <Route
            path={routes.convertProspect}
            element={
              <SuspensePage>
                <ManageProspect />
              </SuspensePage>
            }
          />
          <Route
            path={routes.editOfficeSpecialist}
            element={
              <SuspensePage>
                <ManageOfficeSpecialist />
              </SuspensePage>
            }
          />
        </Route>
        <Route
          path={routes.showOfficeSpecialist}
          element={
            <SuspensePage>
              <ShowOfficeSpecialist />
            </SuspensePage>
          }
        />
        <Route
          path={routes.editAdminAccount}
          element={
            <SuspensePage>
              <EditAccount />
            </SuspensePage>
          }
        />
        <Route
          path={routes.journalisationConnexions}
          element={
            <SuspensePage>
              <JournalisationConnexion />
            </SuspensePage>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to={routes.specialistList} replace />} />
    </Routes>
  );
}
